import { memo, useMemo } from 'react';
import { ICardListItemState, ICategoryListFilters } from '../../types';
import { CategoryCard } from './CategoryCard';

interface ICardListProps {
  list: ICardListItemState[];
  filters: ICategoryListFilters;
}

export const CardList: React.FC<ICardListProps> = memo(({ list, filters }) => {
  const mappedList = useMemo(() => {
    let updArr: ICardListItemState[] = [...list];

    if (filters.price.includes('high to low')) {
      updArr.sort((a, b) => b.price - a.price);
    } else if (filters.price.includes('low to high')) {
      updArr.sort((a, b) => a.price - b.price);
    } else {
      updArr.sort((a, b) => a.index - b.index);
    }

    if (filters.sub.length > 0) {
      updArr = updArr.filter((card) => card.categories.some((cat) => cat.slug === filters.sub[0]));
    }

    // remove all duplicates
    updArr = updArr.filter(
      (card, index, self) => index === self.findIndex((t) => t.id === card.id)
    );

    const renderCardArr: React.ReactNode[] = updArr.reduce<React.ReactNode[]>(
      (result, card, index) => {
        const { id, cardDetails, tags } = card;

        let renderFlag = true;

        const newLanguages: string[] = [];

        const cardTags = tags.map((tag) => tag.slug);

        if (cardDetails) {
          if (filters.size.length > 0 && !filters.size.includes(cardDetails.size)) {
            renderFlag = false;
          }

          if (filters.tags.length > 0 && !cardTags.some((r) => filters.tags.includes(r))) {
            renderFlag = false;
          }

          if (!newLanguages.includes(cardDetails.language)) {
            newLanguages.push(cardDetails.language);
          }
        }

        if (
          filters.language.length > 0 &&
          !filters.language.some((lang) => newLanguages.includes(lang))
        ) {
          renderFlag = false;
        }

        if (renderFlag) {
          result.push(
            <div key={`${id}-${index}`} className="list-item">
              <CategoryCard card={card} />
            </div>
          );
        }

        return result;
      },
      []
    );

    return renderCardArr;
  }, [list, filters]);

  if (mappedList.length === 0) {
    return (
      <div className="not-found-wrap">
        <div className="head">
          <h1>Not Found</h1>
        </div>
        <div className="content">
          <p>Sorry, but you are looking for something that isn't here.</p>
        </div>
      </div>
    );
  }

  return mappedList;
});
